import IMEIBasedSuccessRateTableBodyView from "./imei-based-success-rate-table-body.view";
import IMEIBasedSuccessRateTableHeaderDayView from "./imei-based-success-rate-table-header-day.view";
import IMEIBasedSuccessRateTableHeaderPropView from "./imei-based-success-rate-table-header-prop.view";
import IMEIBasedSuccessRateTableHeaderWeekView from "./imei-based-success-rate-table-header-week.view";

export default function IMEIBasedSuccessRateTableView() {

  return {
    view: (vnode) => {

      const { tableData, handleClickDownloadRawDataFromCell } = vnode.attrs;

      return m(".table-responsive",
        m("table.table.table-bordered",
          m("thead.thead-bggrey",
            m(IMEIBasedSuccessRateTableHeaderWeekView, { weeks: tableData.groupByWeeks }),
            m(IMEIBasedSuccessRateTableHeaderDayView, { weeks: tableData.groupByWeeks }),
            m(IMEIBasedSuccessRateTableHeaderPropView, { weeks: tableData.groupByWeeks })
          ),
          m(IMEIBasedSuccessRateTableBodyView, { data: tableData, handleClickDownloadRawDataFromCell })
        )
      )
    }
  }
}